module.exports = __webpack_public_path__ + "img/world.31c2c3c2.svg";